<template>
	<article class="question-display">
		<strong>{{ $t('MAIN_CONTENT.confirmSubmission.pleaseConfirm') }}</strong>

		<div v-if="timeLimitExceeded"
				class="alert-panel alert-warning">
			<div class="alert-bar">
				<i class="fas fa-exclamation-triangle" />
			</div>
			<div class="alert-message">
				<strong>
					{{ $t('MAIN_CONTENT.confirmSubmission.confirmSubmission_timesUp') }}
				</strong>
				<p>{{ $t('MAIN_CONTENT.confirmSubmission.confirmSubmission_submitMessage') }}</p>
			</div>
		</div>
		<div v-else-if="!!unansweredQuestions || !!unansweredExtraCredit || !!unsavedAnswers"
				class="alert-panel alert-warning">
			<div class="alert-bar">
				<i class="fas fa-exclamation-triangle" />
			</div>
			<div class="alert-message">
				<strong>
					{{ $t('MAIN_CONTENT.confirmSubmission.takeTester_itAppearsThatYouHave') }}
				</strong>
				<ul>
					<li v-if="unsavedAnswers ">
						<b>
							{{ $t('MAIN_CONTENT.confirmSubmission.takeTester_answersNotSaved', { count: unsavedCount } ) }}
						</b>
					</li>
					<li v-if="unansweredQuestions">
						<b>
							{{ $t('MAIN_CONTENT.confirmSubmission.takeTester_questionsUnanswered', { count: unansweredQuestions } ) }}
						</b>
					</li>
					<li v-if="unansweredExtraCredit">
						<b>
							{{ $t('MAIN_CONTENT.confirmSubmission.takeTester_extraCreditUnanswered', { count: unansweredExtraCredit } ) }}
						</b>
					</li>
				</ul>
				<p>
					{{ $t('MAIN_CONTENT.confirmSubmission.returnToQuestionLinkBegin') }}
					<a href="#question-nav">
						{{ $t('MAIN_CONTENT.confirmSubmission.returnToQuestionLinkMiddle') }}
					</a>
					{{ $t('MAIN_CONTENT.confirmSubmission.returnToQuestionLinkEnd') }}
				</p>
			</div>
		</div>

		<div v-else
				class="alert-panel alert-info">
			<div class="alert-bar">
				<i class="fas fa-info-circle" />
			</div>
			<div class="alert-message">
				<strong>{{ $t('MAIN_CONTENT.confirmSubmission.takeTester_readyToSubmit') }}</strong>
				<p v-if="testPreview.TEST.SINGLE_SITTING_COMPLETION_FLG">
					{{ $t('MAIN_CONTENT.confirmSubmission.takeTester_singleSittingMessage') }}
				</p>
			</div>
		</div>

		<test-buttons @test-submitted="submitTest()" />
	</article>
</template>

<script>
	import { mapState,mapActions,mapMutations } from "vuex";
	import testButtons from "./testButtons.vue";

	export default {
		components : { testButtons },
		computed: {
			...mapState( {
				testPreview: state => {
					return state.testTaker.testPreview;
				},
				questions: state => {
					return state.testTaker.testPreview.QUESTIONS.filter( q => {
						return !q.TEST_QUESTION_PARENT_RID; 
					} );
				},
				studentAnswers: state => {
					return state.testTaker.testPreview.STUDENT_ATTEMPT.ANSWERS;
				},
				activeQuestion: state => {
					return state.testTaker.activeQuestion;
				},
				unsavedCount: state => {
					return Object.keys( state.testTaker.unsavedChanges ).length;
				},
				timeLimitExceeded: state => {
					return state.testTaker.timeLimitExceeded;
				}
			} ),
			// returns true if unsaved answers and immediate feedback is on
			unsavedAnswers() {
				return this.testPreview.TEST.STUDENT_IMMEDIATE_FEEDBACK && this.unsavedCount;
			},
			// returns unanswered regular question count
			unansweredQuestions() {
				return this.questions.filter( q=> {
					return !q.EXTRA_CREDIT_FLG && !this.studentAnswers[ q.TEST_QUESTION_RID ];
				} ).length;
			},
			//returns unanswered extra credit question count
			unansweredExtraCredit() {
				return this.questions.filter( q=> {
					return q.EXTRA_CREDIT_FLG && !this.studentAnswers[ q.TEST_QUESTION_RID ]; 
				} ).length;
			}
		},
		methods: {
			...mapMutations( [ "updateState","toggleQuestionFlag" ] ),
			...mapActions( [ "submitTest" ] )
		}
	};
</script>
